import { setConfigStateById } from '../ConfigContext';

export const setRegion = (setState: setConfigStateById) => (region: string) => {
  setState('SET_REGION', (s) => ({
    ...s,
    region,
  }));
};
